import styled from "styled-components"

/**
 * 8:3 ratio image.
 */
const ImageHeader = styled.img`
  aspect-ratio: 8 / 3;
  width: 100%;
  max-width: 100vw;
  object-fit: cover;
`

export default ImageHeader
